export const colors = {
  BRAND_PRIMARY:          '#026cb6',
  BRAND_SECONDARY:        '#041e42',
  BRAND_SECONDARY_40:     'rgba(4, 30, 66, 0.4)',
  BRAND_LIGHT:            '#0093d0',
  BRAND_LIGHTER:          '#13b5ea',
  BRAND_LIGHTER_20:       'rgba(19, 181, 234, 0.2)',
  BRAND_LIGHTEST:         '#89d4e3',
  WARNING:                '#e7b720',
  SUCCESS:                '#398602',
  DANGER:                 '#f06172',
  INFO:                   '#6ba9da',
  GRAY_DARKEST:           '#606060',
  GRAY_DARKER:            '#909090',
  GRAY_DARK:              '#808080',
  GRAY:                   '#c0c0c0',
  GRAY_LIGHT:             '#e0e0e0',
  GRAY_LIGHTER:           '#e6e6e6',
  GRAY_LIGHTEST:          '#ebebeb',
  WHITE_SMOKE:            '#f5f5f5',
  WHITE_SMOKE_LIGHT:      '#f9f9f9'
};